module.exports = __webpack_public_path__ + "img/BFQY.de4ef4b1.png";